import React from 'react';
import { MailCheck } from 'lucide-react';

/**
 * "Check your inbox" confirmation panel rendered after a magic-link request
 * succeeds. Pure presentational — receives the email and the API response
 * shape `{ message, expires_in_minutes }`.
 */
export const AuthSentPanel = ({ email, sent, onUseDifferentEmail }) => (
  <div className="space-y-5" data-testid="auth-sent-panel">
    <div className="flex items-start gap-3 bg-[#00FF00]/5 border border-[#00FF00]/30 rounded-lg p-4">
      <MailCheck className="w-6 h-6 text-[#00FF00] shrink-0 mt-0.5" />
      <div className="text-sm">
        <p className="text-white font-semibold break-all">{email}</p>
        <p className="text-gray-400 mt-1">{sent.message}</p>
      </div>
    </div>

    <div className="text-xs text-gray-500 leading-relaxed">
      Open the email titled <span className="text-gray-300">"Sign in to CyberInsti"</span> and tap{' '}
      <span className="text-[#00FF00] font-semibold">Sign into CyberInsti</span> to finish signing in.
      Link expires in {sent.expires_in_minutes ?? 15} minutes. Don&apos;t see it? Check your spam folder.
    </div>

    <button
      type="button"
      onClick={onUseDifferentEmail}
      data-testid="auth-different-email-btn"
      className="text-sm text-gray-400 hover:text-white"
    >
      Use a different email
    </button>
  </div>
);
